import { helpers } from '../utils';

export const ACTION_HEADER_UPDATE = 'header/update';

export default {
  namespace: 'header',

  state: {
    title: null,
    description: null,
    variable: null,
  },

  reducers: {
    updateStore(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },

  effects: {
    * update({ payload: { title, description, variable } }, { put }) {
      try {
        yield put({
          type: 'updateStore',
          payload: {
            title,
            description,
            variable,
          },
        });
      } catch (e) {
        helpers.processException(e);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/models/header.js